export var CLOUD_EXERCISE = 'CloudExercise';
export var EXPORTED_EXERCISES = [CLOUD_EXERCISE];